import { render, staticRenderFns } from "./medical-documents.vue?vue&type=template&id=1204aa1d&scoped=true&"
import script from "./medical-documents.vue?vue&type=script&lang=js&"
export * from "./medical-documents.vue?vue&type=script&lang=js&"
import style0 from "./medical-documents.vue?vue&type=style&index=0&id=1204aa1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1204aa1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1204aa1d')) {
      api.createRecord('1204aa1d', component.options)
    } else {
      api.reload('1204aa1d', component.options)
    }
    module.hot.accept("./medical-documents.vue?vue&type=template&id=1204aa1d&scoped=true&", function () {
      api.rerender('1204aa1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/documents/medical-documents.vue"
export default component.exports